/*
* BuroEcl
* Copyright (c) 2023 Buroclic. All rights reserved.
* 
* This file contains functions that could be
* use somewhere else in the code as printing function
*/

import html2canvas from "html2canvas";

export interface PrintOptions {
    pageTitle?: string;
    logoBase64?: string;
    orientation?: 'portrait' | 'landscape';
}



/**
   * Prints the provided element's content by
   * duplicating it and hidding every other component.
   * @author Mickaël "Naxe67" APPPEL
   * @since 2024-05-03
   * @param {HTMLElement | null} element 
   * @param {printOptions} options 
   * @returns {void}
   */
export const printElement = (element: HTMLElement | null, options?: PrintOptions): void => {
    if (!element) return;

    html2canvas(element).then(canvas => {
        // save old states
        const root : HTMLElement | null = document.getElementById('root');
        const originalRootStyle :string | null | undefined = root?.getAttribute('style');
        const initialTitle :string = document.title;

        // Create div that will be printed
        const printContainer :HTMLDivElement = document.createElement('div');
        printContainer.setAttribute('style', 'width: 100vw; height: 100vh; display: flex; flex-direction: column;')

        // Create an image containing a screenshot of the targetted element
        const contentAsImg :HTMLImageElement = new Image();
        contentAsImg.src = canvas.toDataURL('image/png');

        // Handle logo option
        if (options?.logoBase64) {
            const logoContainer :HTMLDivElement = document.createElement('div');
            const logoImg :HTMLImageElement = new Image();
            logoContainer.setAttribute('style', 'object-fit: contain; max-height: 10vh; max-width: 25vw; margin-bottom: 1rem;')
            logoImg.src = options.logoBase64;
            logoImg.style.height = '10vh';
            logoImg.style.width = 'auto';
            logoContainer.appendChild(logoImg);

            printContainer.appendChild(logoContainer);
        }

        // Handle CSS properties
        // including orientation
        const printStyle :HTMLStyleElement = document.createElement('style');
        printStyle.textContent = `
        @media print {
            @page {
                ${options?.orientation === 'landscape' ? 'size: landscape;' : ''}
                
            }
        }`;
        document.head.appendChild(printStyle)

        // Handle title
        if (options?.pageTitle) document.title = options?.pageTitle;

        // Add the content and the element to be printed to the body
        printContainer.appendChild(contentAsImg);
        document.body.appendChild(printContainer);

        // Edit CSS to improve printing experience
        root?.setAttribute('style', 'display: none;');
        contentAsImg.onload = () => {
            window.print();
            root?.setAttribute('style', originalRootStyle || '');
            document.title = initialTitle;
            document.head.removeChild(printStyle);
            document.body.removeChild(printContainer);
        };
    })
}